import apiClient from '../apiClient';
import { GET_CITY_URL } from '../apiUrl';

const getCityInCountryAllApi = () => {
  return apiClient.get(GET_CITY_URL);
};

export default getCityInCountryAllApi;
